// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\shared\\\\EventsGrid\\\\EventsGrid.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\shared\\EventsGrid\\EventsGrid.tsx");
  import.meta.hot.lastModified = "1759351482707.0222";
}
// REMIX HMR END

import { EventCard } from "./components/EventCard";

// const eventsData: Event[] = [
//   {
//     id: "1",
//     image: "/images/home/events/event-1.png",
//     date: {
//       day: "08",
//       month: "JUN",
//     },
//     time: "03:30 PM",
//     title: "EVENT NAME",
//     href: "/events/event-1",
//   },
//   {
//     id: "2",
//     image: "/images/home/events/event-1.png",
//     date: {
//       day: "08",
//       month: "JUN",
//     },
//     time: "03:30 PM",
//     title: "EVENT NAME",
//     href: "/events/event-2",
//   },
//   {
//     id: "3",
//     image: "/images/home/events/event-1.png",
//     date: {
//       day: "08",
//       month: "JUN",
//     },
//     time: "03:30 PM",
//     title: "EVENT NAME",
//     href: "/events/event-3",
//   },
// ];

export function EventsGrid({
  data
}) {
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {data.map(event => <EventCard key={event.id} {...event} />)}
    </div>;
}
_c = EventsGrid;
var _c;
$RefreshReg$(_c, "EventsGrid");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;